var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.045,
    y1: 1.357,
    x2: 1,
    y2: 0.222,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#03952a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bdf033"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#003d4c}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Icon_Notification",
    transform: "translate(-337.246 -42.75)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2007",
    "data-name": "Path 2007",
    className: "cls-1",
    d: "M548.67 236.965a1.007 1.007 0 0 0 .931-.029.7.7 0 0 0 .117-.32l-.022-3.644a4 4 0 0 0-.038-.541l-.79-.014a.316.316 0 0 0-.31.156.37.37 0 0 0-.048.2l.015 3.839a.453.453 0 0 0 .145.353z",
    transform: "translate(-196.868 -179.317)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2008",
    "data-name": "Path 2008",
    className: "cls-1",
    d: "M543.906 367.086a.851.851 0 0 0-.188-.277.921.921 0 0 0-.277-.185.848.848 0 0 0-.344-.069.885.885 0 0 0-.624.254.833.833 0 0 0-.182.277.916.916 0 0 0 0 .685.823.823 0 0 0 .459.457.9.9 0 0 0 .347.066.881.881 0 0 0 .621-.249.859.859 0 0 0 .188-.275.88.88 0 0 0 0-.685z",
    transform: "translate(-190.854 -307.828)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Profile_icon_desktop",
    "data-name": "Profile icon desktop",
    transform: "translate(337.246 42.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile_icon",
    "data-name": "profile icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cuverd_circle",
    "data-name": "cuverd circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1586",
    "data-name": "Path 1586",
    d: "M8.417 9.147a1.055 1.055 0 0 0 .883-.493 12.9 12.9 0 0 1 21.671.023 1.048 1.048 0 0 0 .884.47 1.036 1.036 0 0 0 .884-1.582 14.994 14.994 0 0 0-25.217 0A1.036 1.036 0 0 0 8.4 9.147z",
    transform: "translate(-5.126 -.68)",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1587",
    "data-name": "Path 1587",
    className: "cls-1",
    d: "M30.527 26a1.034 1.034 0 0 0-1.005 1.284 12.916 12.916 0 1 1-25.042 0 1.034 1.034 0 0 0-1-1.285h-.01a1.047 1.047 0 0 0-1.012.8 15 15 0 1 0 29.093 0A1.045 1.045 0 0 0 30.535 26z",
    transform: "translate(-1.998 -15.453)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "bell-exclamation",
    d: "M13.731 10.6c-.887-.843-1.563-1.725-1.563-4.716a4.941 4.941 0 0 0-4.561-4.821V.507a.507.507 0 1 0-1.013 0v.556a4.94 4.94 0 0 0-4.562 4.825c0 2.99-.678 3.873-1.563 4.716a1.472 1.472 0 0 0-.357 1.623 1.51 1.51 0 0 0 1.413.949h11.149a1.51 1.51 0 0 0 1.413-.95 1.472 1.472 0 0 0-.356-1.626zm-1.057 1.558H1.526a.481.481 0 0 1-.359-.823c1.1-1.051 1.879-2.228 1.879-5.45A3.958 3.958 0 0 1 7.1 2.027a3.958 3.958 0 0 1 4.054 3.861c0 3.21.767 4.392 1.877 5.45a.481.481 0 0 1-.357.824zM7.1 15.2a1.013 1.013 0 0 1-1.013-1.013H5.073a2.027 2.027 0 1 0 4.054 0H8.113A1.013 1.013 0 0 1 7.1 15.2z",
    transform: "translate(345.147 49.642)",
    style: {
      fill: "#083d4c",
      stroke: "#083d4c",
      strokeWidth: ".5px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotification);
export default __webpack_public_path__ + "static/media/icon_notification.5edac3f5286fd9b91c473c95bf2bf0ea.svg";
export { ForwardRef as ReactComponent };